import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Helper } from '../../common/helper';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private http: HttpClient) { }

  resetPassword(accountName: string) {

    let paramObject = {
      'accountName': accountName
    }

    return this.http.post(Helper.API_URL() + '/api/General/ResetPassword', paramObject);
  }

  resetPasswordUpdate(token: string, newPassword: string) {

    let paramObject = {
      'token': token,
      'newPassword': newPassword,
    }

    return this.http.post(Helper.API_URL() + '/api/General/ResetPasswordUpdate', paramObject);
  }

}
